import {
	Component,
	Input,
	OnInit,
	Signal,
	signal,
	TemplateRef
}                            from '@angular/core';
import { AllowedTabSetEnum } from '@core/interfaces/common.interfaces';
import { SvgTypeEnum }       from '@shared/components/svg/svg.model';
import { TabsetComponent }   from '@shared/components/tabset/tabset.component';


@Component( {
	selector: 'app-tab-item',
	templateUrl: './tab-item.component.html',
	styleUrls: [ './tab-item.component.scss' ]
} )

export class TabItemComponent implements OnInit {

	@Input() active = false;
	@Input() templateRefAppended: TemplateRef<HTMLElement>;
	@Input() templateRefPrepended: TemplateRef<HTMLElement>;
	@Input() iconClass: string;
	@Input() identifier: AllowedTabSetEnum;
	@Input() isDisabled: Signal<boolean> = signal( false );
	@Input() isRendered: boolean = true;
	@Input() svgType: SvgTypeEnum;
	@Input() tooltipForDisabled: string;
	@Input() title: string;

	constructor(
		private readonly _tabsetComponent: TabsetComponent
	) {}

	ngOnInit(): void {
		if ( this.isRendered ) {
			this._tabsetComponent.addTab( this );
		}
	}
}
